import Vue from 'vue'
import { VersaoDaTela } from './versao-da-tela'

/**
 * O botão de troca entre a versão clássica e a nova de uma tela fica na barra do app, igual e no mesmo lugar nas duas
 * versões, no padrão do "Dashboard clássico" do Início. A barra e a tela são componentes separados da rota: a tela
 * registra aqui o que o botão mostra e faz, e a barra desenha o botão enquanto houver registro.
 */
export interface TrocaDeTelaNaBarra {
	/** A versão que o botão abre. */
	destino: VersaoDaTela
	/** Completa a dica do botão: "Abrir a nova tela da loja". */
	assunto: string
	trocando: boolean
	/** Um pulso no botão, para mostrar por onde se troca. */
	destacar: boolean
	trocar: () => void
}

export const trocaDeTela = Vue.observable({ atual: null as TrocaDeTelaNaBarra | null })

/**
 * Tira o registro da barra só se ainda for o dele: na troca entre duas rotas com botão, a tela nova pode registrar
 * antes de a anterior ser destruída.
 */
export function sairDaBarra(registro: TrocaDeTelaNaBarra | null) {
	if (registro && trocaDeTela.atual === registro) trocaDeTela.atual = null
}
